import axios from 'axios';

export function getVariables() {
    return axios.get('/api/variables');
}

export function updateVariable(variable) {
    return axios.put('/api/variables/', {...variable});
}
